import Phaser from "phaser";
import WebFontFile from "./FontLoader";

export default class GameOver extends Phaser.Scene {
  preload() {
    const fonts = new WebFontFile(this.load, "Press Start 2P");
    this.load.addFile(fonts);
  }

  create() {
    const width = this.scale.width;
    const height = this.scale.height;
    const text = this.add.text(width / 2, height / 2, "Game Over", {
      fontSize: 40,
      fontFamily: "'Press Start 2P'",
      color: "#f38ba8"
    });
    text.setOrigin(0.5, 0.5);

    const pressSPACE = this.add.text(width / 1.5, height / 1.7, 'Press SPACE To Restart', {
      fontSize: 13,
      fontFamily: "'Press Start 2P'",
    });
    pressSPACE.setOrigin(0.5);

    this.input.keyboard.once("keydown-SPACE", () => {
      this.scene.start('game');
    })
  }
}
